<form (click)="debugForm(constructor.name)" (keydown)="(null)">
  <mat-form-field class="w-[calc(100%-64px)]">
    <mat-label class="text-xl font-semibold">Adresse e-mail</mat-label>
    <input [formField]="formTree.email" matInput />
    <mat-error>Email invalide</mat-error>
  </mat-form-field>
</form>
